import Product from '../components/Product';

export default class StaticProduct {
  constructor(section) {
    this.product = new Product({ el: section.el, data: section.data });
  }

  onSectionUnload() {
    this.product.unload();
  }
}
